/** Removes undefined fields so Firestore can accept the patch. */
export function stripUndefined<T extends Record<string, unknown>>(patch: T): Partial<T> {
  const out: Record<string, unknown> = {}
  for (const [key, value] of Object.entries(patch)) {
    if (value !== undefined) out[key] = value
  }
  return out as Partial<T>
}

/** Firestore attaches a `code` to its errors; nothing else in the app throws these. */
function firestoreCode(error: unknown): string | null {
  if (error && typeof error === "object" && "code" in error) {
    const code = (error as { code: unknown }).code
    if (typeof code === "string") return code
  }
  return null
}

/** Maps Firestore errors to messages suitable for the UI. */
export function describeWriteError(error: unknown): string {
  switch (firestoreCode(error)) {
    case "permission-denied":
      return "That change was refused by the database. The session rules may have expired."
    case "unavailable":
    case "deadline-exceeded":
      return "You look offline. The change is saved on this device and will sync when the connection is back."
    case "not-found":
      return "That is no longer there — someone may have removed it."
    case "aborted":
    case "failed-precondition":
      return "Someone else changed this at the same time. Try again."
    case "resource-exhausted":
      return "The database is over its quota for today."
    default:
      if (error instanceof Error && error.message) return error.message
      return "That change did not save."
  }
}
